<!-- eslint-disable @typescript-eslint/no-use-before-define -->
<template>
    <!-- 提出一个新需求-->
    <vxe-modal
        v-model="formInput.isShow"
        :title="formInput.title"
        width="840"
        height="620"
        @close="closeReqEvent"
        show-zoom
        resize
        remember
        show-footer
    >
        <template #default>
            <vxe-form
                :data="formInput.formData"
                :rules="formInput.formRules"
                title-align="right"
                ref="rForm"
                title-width="60"
            >
                <vxe-form-item
                    title="开发编号"
                    field="processID"
                    span="12"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-input
                            v-model="formInput.formData.processID"
                            readonly
                            placeholder="审批通过后系统自动生成"
                            disabled
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="数字员工名称"
                    field="processName"
                    :title-prefix="{
                        content: '请填写数字员工名称，并非个人姓名或工号',
                        icon: 'vxe-icon-question-circle-fill',
                    }"
                    span="12"
                    title-width="150px"
                >
                    <template #default>
                        <vxe-input
                            v-model="formInput.formData.processName"
                            placeholder="请填写课题名称，非个人姓名或工号"
                            clearable
                            :disabled="allInputDisable"
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="工作场景描述"
                    field="processDesc"
                    span="24"
                    title-width="120px"
                >
                    <vxe-textarea
                        v-model="formInput.formData.processDesc"
                        placeholder="填写（流程、痛点、解决方案）"
                        maxlength="500"
                        show-word-count
                        :disabled="allInputDisable"
                    ></vxe-textarea>
                </vxe-form-item>
                <vxe-form-item
                    title="场景业务价值"
                    field="sceneBussValue"
                    span="24"
                    title-width="120px"
                >
                    <vxe-textarea
                        v-model="formInput.formData.sceneBussValue"
                        placeholder="填写（体验、收益、效率）"
                        maxlength="500"
                        show-word-count
                        :disabled="allInputDisable"
                    ></vxe-textarea>
                </vxe-form-item>
                <vxe-form-item
                    title="申请人(孵化者)"
                    field="bussName"
                    span="10"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-input
                            v-model="formInput.formData.bussName"
                            placeholder="请输入姓名"
                            readonly
                            :disabled="allInputDisable"
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item span="2">
                    <template #default>
                        <vxe-button
                            @click="selectUser(0)"
                            :disabled="
                                proxy.$store.state.isAdmin == '0' ||
                                allInputDisable
                            "
                            >选择</vxe-button
                        >
                    </template>
                </vxe-form-item>

                <vxe-form-item
                    title="总部"
                    field="divison"
                    span="12"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-input
                            v-model="formInput.formData.divison"
                            placeholder="请输入总部"
                            readonly
                            :disabled="allInputDisable"
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="部门"
                    field="dept"
                    span="12"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-input
                            v-model="formInput.formData.dept"
                            placeholder="请输入部门"
                            readonly
                            :disabled="allInputDisable"
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="科室"
                    field="office"
                    span="12"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-input
                            v-model="formInput.formData.office"
                            placeholder="请输入科室"
                            :disabled="allInputDisable"
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="部门窗口"
                    field="winMan"
                    span="12"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-input
                            v-model="formInput.formData.winMan"
                            readonly
                            :disabled="allInputDisable"
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="科长"
                    field="leader"
                    span="10"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-input
                            v-model="formInput.formData.leader"
                            readonly
                            :disabled="allInputDisable"
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item span="2">
                    <template #default>
                        <vxe-button
                            @click="selectUser(2)"
                            :disabled="allInputDisable"
                            >选择</vxe-button
                        >
                    </template>
                </vxe-form-item>

                <vxe-form-item
                    title="计划部署平台"
                    field="planPlatform"
                    span="12"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-select
                            transfer
                            v-model="formInput.formData.planPlatform"
                            :options="showPlanPlatformOptions"
                            placeholder="请选择计划部署平台"
                            :disabled="allInputDisable"
                            @change="onPlatformChange"
                        >
                        </vxe-select>
                    </template>
                </vxe-form-item>

                <vxe-form-item
                    title="优先级"
                    field="selfLevel"
                    span="12"
                    title-width="120px"
                    :visible="false"
                >
                    <template #default>
                        <vxe-select
                            transfer
                            v-model="formInput.formData.selfLevel"
                            placeholder="请选择优先级自判"
                            clearable
                            :disabled="allInputDisable"
                        >
                            <vxe-option value="1" label="低"></vxe-option>
                            <vxe-option value="2" label="中"></vxe-option>
                            <vxe-option value="3" label="高"></vxe-option>
                        </vxe-select>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="开发工具或语言"
                    field="otherPlatform"
                    span="12"
                    title-width="130px"
                >
                    <template #default>
                        <vxe-input
                            v-model="formInput.formData.otherPlatform"
                            placeholder="请输入开发工具或语言"
                            :disabled="
                                formInput.formData.planPlatform !== 'PT006' ||
                                allInputDisable
                            "
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="计划上线时间"
                    field="planPublishDate"
                    span="12"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-input
                            transfer
                            v-model="formInput.formData.planPublishDate"
                            type="date"
                            placeholder="请输入计划上线时间"
                            :disabled="allInputDisable"
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="辅导老师"
                    field="isNeedTutor"
                    span="12"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-select
                            v-model="formInput.formData.isNeedTutor"
                            placeholder="辅导老师"
                            clearable
                            transfer
                            :disabled="allInputDisable"
                            @change="tutorTypeChange"
                        >
                            <vxe-option
                                value="1"
                                label="自动分配辅导老师"
                            ></vxe-option>
                            <vxe-option
                                value="2"
                                label="指定辅导老师"
                            ></vxe-option>
                        </vxe-select>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="指定辅导老师"
                    field="tutorUID"
                    span="12"
                    title-width="120px"
                    :visible="formInput.formData.isNeedTutor == '2'"
                >
                    <template #default>
                        <vxe-select
                            transfer
                            v-model="formInput.formData.tutorUID"
                            :options="formInput.allTutors"
                            placeholder="请选择辅导老师"
                            :disabled="allInputDisable"
                        >
                        </vxe-select>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="FP智能估算"
                    field="FPCount"
                    span="10"
                    title-width="120px"
                    :visible="formInput.formData.status == '5'"
                >
                    <template #default>
                        <vxe-input
                            v-model="formInput.formData.FPCount"
                            readonly
                            :disabled="allInputDisable"
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    span="2"
                    :visible="formInput.formData.status == '5'"
                >
                    <template #default>
                        <vxe-button @click="estimateFP" status="primary"
                            >估算</vxe-button
                        >
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="是否涉及AI"
                    field="isAI"
                    span="12"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-select
                            transfer
                            v-model="formInput.formData.isAI"
                            placeholder="请选择是否涉及AI"
                            clearable
                            :disabled="allInputDisable"
                        >
                            <vxe-option value="0" label="否"></vxe-option>
                            <vxe-option value="1" label="是"></vxe-option>
                        </vxe-select>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    span="24"
                    title-align="center"
                    title-width="400px"
                >
                    <template #default>
                        <div
                            style="
                                color: #ff0000;
                                text-align: center;
                                font-size: 20px;
                            "
                        >
                            RPA类数字员工<span
                                style="color: #5bb3fd; font-weight: bold"
                                >请勿</span
                            >使用UiPath开发，请使用【<a
                                href="https://coe.dongfeng-nissan.com.cn/admin/forum/postsPage/postsContent?searcharticle=1487"
                                target="_blank"
                                >派神易</a
                            >】进行开发
                        </div>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="需求取消原因"
                    span="24"
                    title-align="left"
                    title-width="100px"
                    :visible="isCancelInput"
                >
                    <template #default>
                        <vxe-input
                            v-model="cancelInfo"
                            placeholder="需求取消时填写"
                        ></vxe-input>
                    </template>
                </vxe-form-item>
            </vxe-form>
        </template>
        <template #footer v-if="isViewFooter">
            <div style="text-align: center; width: 100%">
                <vxe-button @click="save" icon="fa fa-save" status="success">
                    保存
                </vxe-button>
                <vxe-button @click="submit" icon="fa fa-check" status="primary"
                    >提交
                </vxe-button>
                <vxe-button
                    @click="retire"
                    icon="fa fa-trash-o"
                    status="danger"
                    v-if="isCancelInput"
                >
                    需求取消
                </vxe-button>
            </div>
        </template>
    </vxe-modal>
    <vxe-modal title="选择用户" v-model="iShowSelectUser" width="640">
        <template #default>
            <div>
                <vxe-form>
                    <vxe-form-item title="关键字" :item-render="{}">
                        <template #default>
                            <vxe-input
                                v-model="userTablePager.searchKey"
                                placeholder="请输入姓名或邮箱"
                                clearable
                            ></vxe-input>
                        </template>
                    </vxe-form-item>
                    <vxe-form-item>
                        <template #default>
                            <vxe-button
                                @click="findUserData"
                                @keyup.enter="findUserData"
                                >查询</vxe-button
                            >
                        </template>
                    </vxe-form-item>
                </vxe-form>
            </div>
            <div>
                <vxe-table
                    class="mytable-scrollbar"
                    :data="dtUser"
                    ref="xTableUser"
                    height="300"
                    @cell-dblclick="chooseUser"
                    highlight-hover-row
                    highlight-current-row
                >
                    <vxe-column
                        type="seq"
                        field="Id"
                        title="序号"
                        width="50"
                    ></vxe-column>
                    <vxe-column
                        field="UserName"
                        title="姓名"
                        width="120"
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="JobZb"
                        title="总部"
                        width="100"
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="JobName"
                        title="部门"
                        width="120"
                        sortable
                        resizable
                    ></vxe-column>
                    <vxe-column
                        field="UserMail"
                        title="邮箱"
                        width="200"
                        sortable
                        resizable
                    ></vxe-column>
                    <vxe-column
                        field="uid"
                        title="uid"
                        width="10"
                        :visible="false"
                    ></vxe-column>
                </vxe-table>
            </div>
            <div>
                <vxe-pager
                    background
                    v-model:current-page="userTablePager.currentPage"
                    v-model:page-size="userTablePager.pageSize"
                    :total="userTablePager.totalResult"
                    @page-change="handlePageChangeUser"
                    size="small"
                >
                </vxe-pager>
            </div>
        </template>
    </vxe-modal>
    <FPEstimate ref="fpestimateRef" @updateTotal="handleTotal"></FPEstimate>
</template>

<script setup>
import {
    onMounted,
    reactive,
    ref,
    getCurrentInstance,
    defineExpose,
    defineEmits,
    computed,
} from "vue";
import { useRouter } from "vue-router";
import { VXETable } from "vxe-table";
import Qs from "qs";
import FPEstimate from "../requireManage/FPEstimate.vue";

const router = useRouter();
const { proxy } = getCurrentInstance();

const formInput = reactive({
    title: "提出一个新需求",
    isShow: false,
    planPlatform: [],
    allTutors: [],
    winMan: "",
    winManUID: "",
    FPViewOnly: true,
    formData: {
        Id: "",
        processID: "",
        processName: "",
        processDesc: "",
        bussName: "",
        divison: "",
        status: "",
        dept: "",
        office: "",
        bussEmail: "",
        selfLevel: "2", //优先级自判 中
        requireNo: "",
        leader: "",
        leaderUID: "",
        winMan: "",
        winManUID: "",
        devDifficulty: "1", //默认低
        planPublishDate: "",
        sceneBussValue: "",
        isNeedTutor: "1", //默认自动分配辅导老师
        planPlatform: "",
        tutorName: "",
        tutorUID: "",
        otherPlatform: "",
        creator: "",
        developer: "",
        developerMail: "",
        functionType: "1", //默认值
        developType: "1", //默认值
        saveButDisable: false,
        submitBtnDisable: false,
        FPCount: 0,
        isAI: "0",
    },
    formRules: {
        processID: [{ required: false, message: "开发编号不能为空" }],
        processName: [{ required: true, message: "请输入数字员工名称" }],
        processDesc: [{ required: true, message: "请输入工作场景描述" }],
        bussName: [{ required: true, message: "请输入姓名" }],
        divison: [{ required: true, message: "请输入总部" }],
        dept: [{ required: true, message: "请输入部门" }],
        office: [{ required: true, message: "请输入科室" }],
        bussEmail: [{ required: true, message: "请输入邮箱" }],
        selfLevel: [{ required: true, message: "请选择优先级" }],
        winMan: [{ required: true, message: "请选择部门窗口人" }],
        leader: [{ required: true, message: "请选择科长" }],
        planPublishDate: [{ required: true, message: "请选择计划上线时间" }],
        sceneBussValue: [{ required: true, message: "请输入场景业务价值" }],
        isNeedTutor: [{ required: true, message: "请选择是否需要辅导老师" }],
        planPlatform: [{ required: true, message: "请选择计划部署平台" }],
        tutorUID: [{ required: false, message: "请选择指定辅导老师" }],
        otherPlatform: [{ required: false, message: "请选择开发工具或语言" }],
        FPCount: [{ required: false, message: "请输入FP估算数量" }],
        isAI: [{ required: true, message: "请选择是否涉及AI" }],
    },
});
let allInputDisable = ref(false);
let isViewFooter = ref(true);
let editType = ref("1");
const xTableUser = ref(null);
const rForm = ref(null);
const cancelInfo = ref(""); //需求取消原因
const isCancelInput = ref(false);
const fpestimateRef = ref(null);
const emit = defineEmits(["flashReqList"]);
const openModal = async () => {
    formInput.formData = {
        Id: proxy.$utils.guid(),
        processName: "",
        processID: "",
        processDesc: "",
        bussName: proxy.$store.state.userName,
        divison: proxy.$store.state.jobZb,
        dept: proxy.$store.state.jobName,
        status: "0",
        office: "",
        bussEmail: proxy.$store.state.email,
        selfLevel: "2", //优先级自判 中
        requireNo: "",
        leader: "",
        leaderUID: "",
        winMan: formInput.winMan,
        winManUID: formInput.winManUID,
        devDifficulty: "1",
        planPublishDate: "",
        sceneBussValue: "",
        isNeedTutor: "1", //默认自动分配辅导老师
        planPlatform: "",
        saveButDisable: false,
        submitBtnDisable: false,
        otherPlatform: "",
        creator: proxy.$store.state.userID,
        developer: proxy.$store.state.userName,
        developerMail: proxy.$store.state.email,
        functionType: "1", //默认值
        developType: "1", //默认值
        tutorName: "",
        tutorUID: "",
        FPCount: 0,
        isAI: "",
    };

    formInput.title = "提出一个需求";
    formInput.isShow = true;
    allInputDisable.value = false;
    isViewFooter.value = true;
    isCancelInput.value = false;
    editType.value = "1";
    const $rForm = rForm.value;
    try {
        if ($rForm) {
            await $rForm.reset();
        }
        // const re = await $rForm.clearValidate();
    } catch (e) {
        console.log(e);
    }
};

const closeReqEvent = () => {
    emit("flashReqList");
};
let userSelectType = ref(2); //选择用户类型 1 开发人员 2 领导
let userTablePager = reactive({
    currentPage: 1,
    pageSize: 10,
    totalResult: 0,
    searchKey: "",
});
let iShowSelectUser = ref(false);
//选择用户 type 1 开发人员 2 领导
const selectUser = (type) => {
    userSelectType.value = type;
    userTablePager.searchKey = "";
    findUserData();
    iShowSelectUser.value = true;
};
let dtUser = ref([]);
const findUserData = () => {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: userTablePager.currentPage,
        pageSize: userTablePager.pageSize,
        searchKey: [userTablePager.searchKey, ""],
    };
    proxy.$api.systemManageAPI
        .getUserList(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            // console.log(res.data.Data);
            dtUser = res.data.Data.dataTable;
            userTablePager.currentPage = res.data.Data.currentPage;
            userTablePager.pageSize = res.data.Data.pageSize;
            userTablePager.totalResult = res.data.Data.totalResult;
        })
        .catch((error) => {
            console.log(error);
        });
};
const chooseUser = () => {
    const $table = xTableUser.value;
    if (!$table) {
        console.error("表格实例未找到");
        return;
    }

    const record = $table.getCurrentRecord(); // 获取当前高亮行
    // 或者用复选框选中行：const record = $table.getCheckboxRecords()[0];

    if (!record) {
        VXETable.modal.message({ content: "请选择一行数据", status: "info" });
        return;
    }
    if (userSelectType.value == 0) {
        //开发人员
        formInput.formData.developer = record.UserName;
        formInput.formData.developerMail = record.UserMail;
        formInput.formData.bussName = record.UserName;
        formInput.formData.divison = record.JobZb;
        formInput.formData.dept = record.JobName;
        formInput.formData.bussEmail = record.UserMail;
        formInput.formData.creator = record.uid;
    } else if (userSelectType.value == 2) {
        //领导
        formInput.formData.leader = record.UserName;
        formInput.formData.leaderUID = record.uid;
    }

    iShowSelectUser.value = false;
};
const tutorTypeChange = () => {
    formInput.formRules.tutorUID[0].required =
        formInput.formData.isNeedTutor == "2";
};
const onPlatformChange = () => {
    if (formInput.formData.planPlatform !== "PT006") {
        formInput.formData.otherPlatform = "";
        formInput.formRules.otherPlatform[0].required = false;
    } else {
        formInput.formRules.otherPlatform[0].required = true;
    }
};
//保存新需求
const save = async () => {
    const $rForm = rForm.value;
    const formErrMap = await $rForm.validate();
    if (formErrMap) {
        return;
    }
    const params = getModel();

    if (formInput.formData.saveButDisable) {
        return;
    }

    //新增
    if (editType.value === "1") {
        proxy.$api.newRequireManageAPI
            .addRequires(Qs.stringify(params))
            .then((res) => {
                if (res.data.Success == false) {
                    VXETable.modal.message({
                        content: res.data.Message,
                        status: "error",
                    });
                    return;
                }
                VXETable.modal.message({
                    content: "保存成功",
                    status: "success",
                });
                editType.value = "2"; //
            })
            .catch((error) => {
                VXETable.modal.alert({ content: error, status: "error" });
                console.log(error);
            });
    } else if (editType.value === "2") {
        //更新
        proxy.$api.newRequireManageAPI
            .updateRequires(Qs.stringify(params))
            .then((res) => {
                if (res.data.Success == false) {
                    VXETable.modal.message({
                        content: res.data.Message,
                        status: "error",
                    });
                    return;
                }
                VXETable.modal.message({
                    content: "保存成功",
                    status: "success",
                });
                editType.value = "2"; //
                emit("flashReqList");
            })
            .catch((error) => {
                VXETable.modal.message({ content: error, status: "error" });
                console.log(error);
            });
    } else if (editType.value === "3") {
        proxy.$api.newRequireManageAPI
            .updateRequiresAdmin(Qs.stringify(params))
            .then((res) => {
                if (res.data.Success == false) {
                    VXETable.modal.message({
                        content: res.data.Message,
                        status: "error",
                    });
                    return;
                }
                VXETable.modal.message({
                    content: "保存成功",
                    status: "success",
                });
                editType.value = "3"; //
                emit("flashReqList");
            })
            .catch((error) => {
                VXETable.modal.alert({ content: error, status: "error" });
                console.log(error);
            });
    }
};
const getModel = () => {
    const requires = {
        Id: formInput.formData.Id,
        status: formInput.formData.status,
        processName: formInput.formData.processName,
        processID: formInput.formData.processID,
        processDesc: formInput.formData.processDesc,
        sceneBussValue: formInput.formData.sceneBussValue,
        creator: formInput.formData.creator,
        bussName: formInput.formData.bussName,
        divison: formInput.formData.divison,
        dept: formInput.formData.dept,
        office: formInput.formData.office,
        busseMail: formInput.formData.bussEmail,
        selfLevel: formInput.formData.selfLevel,
        requireNo: formInput.formData.requireNo,
        leader: formInput.formData.leader,
        leaderUID: formInput.formData.leaderUID,
        planPublishDate: formInput.formData.planPublishDate,
        isNeedTutor: formInput.formData.isNeedTutor,
        planPlatform: formInput.formData.planPlatform,
        functionType: formInput.formData.functionType,
        developType: formInput.formData.developType,
        developer: formInput.formData.developer,
        developerMail: formInput.formData.developerMail,
        devDifficulty: formInput.formData.devDifficulty,
        winMan: formInput.formData.winMan,
        winManUID: formInput.formData.winManUID,
        modifier: proxy.$store.state.userID,
        tutorUID: formInput.formData.tutorUID,
        tutorName:
            getLabelByValue(formInput.allTutors, formInput.formData.tutorUID) ||
            "",
        otherPlatform: formInput.formData.otherPlatform,
        FPCount: formInput.formData.FPCount,
        isAI: formInput.formData.isAI,
    };
    return requires;
};
let submitLoading = ref(false);
//提交需求
const submit = async () => {
    const $rForm = rForm.value;
    const formErrMap = await $rForm.validate();
    if (formErrMap) {
        return;
    }
    submitLoading = true;
    const params = getModel("1");

    proxy.$api.newRequireManageAPI
        .submitRequires(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success === false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            VXETable.modal.message({ content: "提交成功", status: "success" });
            editType.value = "1"; //
            addAuditRecord(formInput.formData.Id, "0");
            emit("flashReqList");
            formInput.isShow = false;
        })
        .catch((error) => {
            VXETable.modal.message({ content: error, status: "error" });
            console.log(error);
        });
};
const retire = async () => {
    const type = await VXETable.modal.confirm("您确定要取消该需求?");
    if (type === "confirm") {
        if (formInput.formData.processName === "") {
            VXETable.modal.message({
                content: "流程名称不能为空",
                status: "warning",
            });
            return;
        }
        if (cancelInfo.value === "") {
            VXETable.modal.message({
                content: "需求取消原因不能为空",
                status: "warning",
            });
            return;
        }
        const params = formInput.formData;

        proxy.$api.requireManageAPI
            .updateRequiresRetire(Qs.stringify(params))
            .then((res) => {
                if (res.data.Success == false) {
                    VXETable.modal.message({
                        content: res.data.Message,
                        status: "error",
                    });
                    return;
                }
                VXETable.modal.message({
                    content: "需求取消成功",
                    status: "success",
                });

                addAuditRecord(3);

                formInput.isShow = false;
                emit("flashReqList");
            })
            .catch((error) => {
                VXETable.modal.message({
                    content: error,
                    status: "error",
                });
                console.log(error);
            });
    }
};
const addAuditRecord = (bussId, status) => {
    //写审核日志
    const params = {
        auditBuId: bussId,
        auditMan: proxy.$store.state.userName,
        auditManUid: proxy.$store.state.userID,
        auditStatus: status, //0发起 1 通过 2 驳回
        auditOpinion: "",
        auditNode: "审核发起",
    };
    proxy.$api.requireManageAPI
        .addAuditRecord(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success === false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
        })
        .catch((error) => {
            console.log(error);
        });
};
const bindHeadquarterWin = () => {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: 1,
        pageSize: 100,
        searchKey: ["", proxy.$store.state.jobZb],
    };
    proxy.$api.digitalDictManageAPI
        .getHeadquarterWinOne(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            if (
                Array.isArray(res.data.Data.dataTable) &&
                res.data.Data.dataTable.length > 0
            ) {
                formInput.winMan = res.data.Data.dataTable[0].userName;
                formInput.winManUID = res.data.Data.dataTable[0].uid;
            }
        })
        .catch((error) => {
            console.log(error);
        });
};
const handlePageChangeUser = () => {
    findUserData();
};
const getLabelByValue = (list, value) => {
    const item = list.find((i) => i.value === value);
    return item ? item.label : null;
};
const bindPlatform = () => {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: 1,
        pageSize: 100,
        searchKey: [""],
    };
    proxy.$api.digitalDictManageAPI
        .getDeployPlatformList(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });

                return;
            }
            formInput.planPlatform = [];
            for (const item of res.data.Data.dataTable) {
                formInput.planPlatform.push({
                    value: item.code,
                    label: item.name,
                });
            }
        })
        .catch((error) => {
            console.log(error);
        });
};
// type 1 新增 2 管理员编辑
const editReqEvent = async (row, type) => {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: 1,
        pageSize: 20,
        searchKey: [row.Id],
    };

    proxy.$api.requireManageAPI
        .getRequireOne(Qs.stringify(params))
        .then(async (res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            formInput.formData = res.data.Data.dataTable[0];

            if (type == 2) {
                //管理员编辑
                formInput.title = "管理员编辑需求";
                allInputDisable.value = false;
                isViewFooter.value = true;
                editType.value = "3"; //管理员更新
                isCancelInput.value = true;
                formInput.FPViewOnly = false;
            } else {
                formInput.FPViewOnly = true;
                if (
                    formInput.formData.status == "1" || // 窗口审核中
                    formInput.formData.status == "2" || //场景组审核中
                    formInput.formData.status == "5" || //已审核
                    formInput.formData.status == "6" //已取消
                ) {
                    formInput.title = "查看需求";
                    allInputDisable.value = true;
                    isViewFooter.value = false;
                } else {
                    formInput.title = "编辑需求";
                    allInputDisable.value = false;
                    isViewFooter.value = true;
                }
                isCancelInput.value = false;
                editType.value = "2"; //更新
            }

            formInput.isShow = true;
            const $rForm = rForm.value;
            try {
                if ($rForm) {
                    await $rForm.reset();
                }
                // const re = await $rForm.clearValidate();
            } catch (e) {
                console.log(e);
            }
        })
        .catch((error) => {
            console.log(error);
        });
};
const bindTechMember = () => {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: 1,
        pageSize: 100,
        searchKey: [""],
    };
    proxy.$api.digitalDictManageAPI
        .getTechMemberList(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });

                return;
            }
            formInput.allTutors = [];
            for (const item of res.data.Data.dataTable) {
                formInput.allTutors.push({
                    value: item.uid,
                    label: item.userName,
                });
            }
        })
        .catch((error) => {
            console.log(error);
        });
};
const estimateFP = () => {
    proxy.$refs.fpestimateRef.openModal(
        formInput.formData.Id,
        formInput.formData.processName,
        formInput.FPViewOnly
    );
};
const handleTotal = (total) => {
    formInput.formData.FPCount = total;
};
onMounted(() => {
    setTimeout(() => {
        bindHeadquarterWin();
        bindPlatform();
        bindTechMember();
    }, 10);
});

// 是否新增
const isAddMode = computed(() => {
    return formInput.formData.status === "0";
});

// 下拉选项
const showPlanPlatformOptions = computed(() => {
    const hideValue = "PT002";

    if (isAddMode.value) {
        return formInput.planPlatform.filter(
            (item) => item.value !== hideValue
        );
    }

    return formInput.planPlatform;
});

defineExpose({ openModal, editReqEvent });
</script>

<style lang="scss" scoped>
.mytable-style .vxe-body--column.col-red {
    background-color: red;
    color: #fff;
}

.active {
    color: green;
}

.error {
    color: red;
}

.audit {
    color: blue;
}
</style>

<style type="text/css">
td.vxe-body--column {
    vertical-align: middle;
}
</style>
